// extracted by css-extract-rspack-plugin
export default {"chatContentWrapper":"thinking-widget__chatContentWrapper___uAtwI"};